export default {
  black: '#000000',
  tricornBlack: '#2F2F30'
}
